import { Button } from '@/components/ui/button';

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { FlexCol } from '@/components/ui/flex';
import { Textarea } from '@/components/ui/textarea';
import { useState, type FC } from 'react';

export const GenerationColumnModal: FC<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  columnGenerationPrompt: string;
  setColumnGenerationPrompt: (prompt: string) => void;
  isGeneratingColumns: boolean;
  handleGenerateColumns: () => void;
}> = ({
  open,
  onOpenChange,
  columnGenerationPrompt,
  setColumnGenerationPrompt,
  isGeneratingColumns,
  handleGenerateColumns,
}) => {
  const [showErrors, setShowErrors] = useState(false);

  const promptError = !columnGenerationPrompt.trim()
    ? 'Instructions are required'
    : undefined;

  const handleSubmit = () => {
    if (promptError) {
      setShowErrors(true);
      return;
    }
    handleGenerateColumns();
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setShowErrors(false);
    }
    onOpenChange(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-[700px]">
        <DialogHeader className="gap-2">
          <DialogTitle>Bulk create columns</DialogTitle>
          <DialogDescription>
            Describe the information you'd like AI to extract from each document
            or database item. New columns will be added to the end of the table.
          </DialogDescription>
        </DialogHeader>
        <FlexCol gap="2">
          <Textarea
            label="Instructions"
            required
            value={columnGenerationPrompt}
            onChange={e => setColumnGenerationPrompt(e.target.value)}
            placeholder="Extract the device type, primary outcomes, adverse events, sample demographics, and study limitations."
            rows={6}
            error={showErrors ? promptError : undefined}
          />
        </FlexCol>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            loading={isGeneratingColumns}
            onClick={handleSubmit}
            className="bg-purple-900 text-white"
            variant="dark"
          >
            Generate
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
